import '.a7{flex:1 1 0;}.ssr-plugin'
import '.gv{border-radius:var(--border-radius-image);}.ssr-plugin'
import '.i9{background-color:var(--palette-steady-stone);}.ssr-plugin'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { Image } from '@app/components/core/image/Image'

export type LandingContentImageColumnProps = {
  imageSrc?: string
}

const LandingContentImageColumn = ({
  imageSrc,
}: LandingContentImageColumnProps) => {
  const isMobile = useMediaQuery()

  const frameHeight = isMobile ? '21rem' : '31rem'

  return imageSrc ? (
    <div className="a7 gv"
      style={{
        height: frameHeight,}}
    >
      <Image
        src={imageSrc}
        alt="Landing content image"
        style={{
          height: '100%',
          width: '100%',
          objectFit: 'contain',
        }}
      />
    </div>
  ) : (
    <div className="a7 gv i9"
      style={{
        minHeight: isMobile ? '20.5rem' : '30.5rem',}}
    />
  )
}

export default LandingContentImageColumn
